module.exports = __webpack_public_path__ + "img/gear-setup.ec21cbb1.jpg";